import { ApolloError } from '@apollo/client'
import { useLazyQuery } from '@apollo/client/react/hooks/useLazyQuery'
import {
    GetContentInsertStatusQuery,
    GetProductTypeContentInsertStatusQuery,
} from 'api/graphQL/queries/contentInsert.queries'
import { GetContentInsertStatusResponse } from 'api/graphQL/types/contentInsert.types'
import { useCallback } from 'react'

export interface FamilyContentInsertStatusQueryProps {
    instanceId: string
    partType: string
    rootArticleContentItemIds: string[]
    productFamilyId: string
    onCompleted?: (data: GetContentInsertStatusResponse) => void
    onError?: (error: ApolloError) => void
}

export interface ProductTypeContentInsertStatusQueryProps {
    instanceId: string
    partType: string
    rootArticleContentItemIds: string[]
    productFamilyId: string
    nodeId: string
    onCompleted?: (data: GetContentInsertStatusResponse) => void
    onError?: (error: ApolloError) => void
}

export const useFamilyContentInsertStatusQuery = ({
    instanceId,
    partType,
    rootArticleContentItemIds,
    productFamilyId,
    onCompleted,
    onError,
}: FamilyContentInsertStatusQueryProps) => {
    const [getFamilyContentInsertStatus] = useLazyQuery<
        GetContentInsertStatusResponse
    >(GetContentInsertStatusQuery(6), {
        variables: {
            instanceId,
            partType,
            rootArticleContentItemIds,
            productFamilyId,
        },
        fetchPolicy: 'no-cache',
        onCompleted,
        onError,
    })

    const fetchFamilyContentInsertStatus = useCallback(() => {
        getFamilyContentInsertStatus()
    }, [getFamilyContentInsertStatus])

    return { fetchFamilyContentInsertStatus }
}

export const useProductTypeContentInsertStatusQuery = ({
    instanceId,
    partType,
    rootArticleContentItemIds,
    productFamilyId,
    nodeId,
    onCompleted,
    onError,
}: ProductTypeContentInsertStatusQueryProps) => {
    const [getProductTypeContentInsertStatus] = useLazyQuery<
        GetContentInsertStatusResponse
    >(GetProductTypeContentInsertStatusQuery(6), {
        variables: {
            instanceId,
            partType,
            rootArticleContentItemIds,
            productFamilyId,
            nodeId,
        },
        fetchPolicy: 'no-cache',
        onCompleted,
        onError,
    })

    const fetchProductTypeContentInsertStatus = useCallback(() => {
        getProductTypeContentInsertStatus()
    }, [getProductTypeContentInsertStatus])

    return { fetchProductTypeContentInsertStatus }
}
